/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';

// import custom components
import CustomTextField from '../../components/Common/FormMUIWrapperComponents/CustomTextField';
import CustomSingleSelectComboBox from '../Common/FormMUIWrapperComponents/CustomSingleSelectComboBox';
import { TEXT_FIELD_CONST } from '../../components/Common/FormMUIWrapperComponents/CustomTextField/Constants';
import { MASK_3_2_4_NUMBER_PATTERN } from '../../components/Common/MaskUtils/MaskPatterns';
import { SELECT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomSingleSelect/Constants';

// import styles
import styles from "./PhysicianAndPracticeInfoForm.styles.module.css";

const PhysicianAndPracticeInfoForm = props => {
    const autocomplete = useSelector(state => state.autocomplete.searchAutocomplete);
    const enrolledPatientData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledPatientData);
    const enrolledStudyData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledOverviewData && state.idtfPatientEnrollment.patientEnrollment.enrolledOverviewData.latest_enrollment)
    const [formData, setFormData] = useState({
        referringPhysician: enrolledStudyData && enrolledStudyData.referring_physician_member ? enrolledStudyData.referring_physician_member : '',
        orderingPhysician: {},
    });
    // initial validation is false, so set error as true
    const [formErrorState, setFormErrorState] = useState(true)
    const [ORDERING_PHYSICIAN, setORDERING_PHYSICIAN] = useState([]);
    const {
        me,
        validateMainForm,
        formNameSpace,
    } = props
    
    // update text field data to state
    const handleFormDataUpdate = (e, stateKey, val) => {
        const { value } = e.target;
        if (stateKey) {
            const tempFormData = { ...formData };
            switch (stateKey) {
                // handle orderingPhysician dd Combobox select
                case 'orderingPhysician':
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                case 'referringPhysician':
                    tempFormData[stateKey] = value;
                default:
                    break;
            }
            setFormData(tempFormData)
        }
    }

    // validate Form state
    const validateForm = (state) => {
        // if state true, means error, so update state
        if (state) {
            setFormErrorState(state)
        } else {
            // check if all required field is filled 
            if (
                // formData.referringPhysician !== '' && 
                !_.isEmpty(formData.orderingPhysician)
            ) {
                setFormErrorState(false)
            }
        }
    }

    useEffect(() => {
        // if form data is updated, pass the updated data to Parent form with error state
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formData])

    // on change of errorState of form
    useEffect(() => {
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formErrorState])

    useEffect(() => {
        if (autocomplete.fetchCompleted) {
            setORDERING_PHYSICIAN(autocomplete.orderingProvider)
            setFormData({
                ...formData,
                // referringPhysician: enrolledStudyData && enrolledStudyData.referring_physician_member ? enrolledStudyData.referring_physician_member : '',
                orderingPhysician: enrolledPatientData && enrolledPatientData.orderingPhysician ? autocomplete.orderingProvider && autocomplete.orderingProvider.find((item)=> {if(item.id ==  enrolledPatientData.orderingPhysician.id) {return item}}) : {}, // Dropdown
            })
        }

    }, [autocomplete.fetchCompleted])

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.title}>Physician and Practice Information</h1>
            <Grid container spacing={2}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                <Grid item xs={6}>
                    <CustomTextField
                        label="Referring Physician"
                        // placeholder='Enter referring physician'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.referringPhysician}
                        stateKey='referringPhysician'
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomSingleSelectComboBox
                        label="Ordering Physician"
                        placeholder='Select Physician'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={ORDERING_PHYSICIAN}
                        mandatory={true}
                        valueKey='value'
                        labelKeys={['lastName', 'firstName']}
                        labelDisplayPrefix='Dr.'
                        labelDisplaySeparator=', '
                        stateKey='orderingPhysician'
                        selectedValue={formData.orderingPhysician}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* <Grid item xs={4}>
                    <CustomTextField
                        mandatory={false}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        disabled={true}
                        value={`Address\ngoes\nhere`}
                        displayOnly={true}
                    />
                </Grid>
                <Grid item xs={8}>
                    Empty space as per figma
                </Grid> */}
                <Grid item xs={4}>
                    <CustomTextField
                        label="Phone"
                        mandatory={false}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        disabled={true}
                        value={`(000) 000-0000`}
                        // value={!me.isFetching ? me.data.teams[0].phoneNumber : ""}
                        displayOnly={true}
                        // maskInput={MASK_3_2_4_NUMBER_PATTERN}
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomTextField
                        label="After hours"
                        mandatory={false}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        disabled={true}
                        value={`(000) 000-0000`}
                        displayOnly={true}
                        // maskInput={MASK_3_2_4_NUMBER_PATTERN}
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomTextField
                        label="Fax"
                        mandatory={false}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        disabled={true}
                        value={`(000) 000-0000`}
                        displayOnly={true}
                        // maskInput={MASK_3_2_4_NUMBER_PATTERN}
                    />
                </Grid>
                {/* ============= End of Grid ============= */}
            </Grid>
            <div style={{marginTop: '20px', fontSize: '15px'}}>Clinical Cardiac Incorporated<br/>4 Your Heart Way<br/>Suite 1000<br/>Los Angeles , CA 99999</div>
        </div>
    );
}

export default PhysicianAndPracticeInfoForm


// WEBPACK FOOTER //
// ./src/views/components/PhysicianAndPracticeInfoForm/PhysicianAndPracticeInfoForm.jsx